import { C, R } from "@/brand/tokens";

/** Boxed form chrome — 1px border, 6–8px radius, teal focus ring. */

export const fieldBase =
  "block w-full font-inter text-[15px] leading-[1.4] py-3 px-4 border transition-colors outline-none";

export const fieldStyle = {
  background: "#FFFFFF",
  borderColor: C.dividerLight,
  borderWidth: "1px",
  borderStyle: "solid",
  borderRadius: R.field,
  color: C.textOnLight,
};

export const fieldFocusStyle = {
  borderColor: C.accentFunctional,
  boxShadow: "0 0 0 3px rgba(47,107,115,0.16)",
};

export function applyFocus(e) {
  Object.assign(e.currentTarget.style, fieldFocusStyle);
}

export function applyBlur(e) {
  Object.assign(e.currentTarget.style, fieldStyle, { boxShadow: "none" });
}
